import RecurringProphyStudy from './studyConfig/RecurringProphyStudy'

export default new RecurringProphyStudy({
  molecule: 'Amitriptyline',
  smallText: 'e.g. Elavil, Vanatrip, Endep',
  dosageOptions: [
    '10mg per day',
    '25mg per day',
    '50mg per day'
  ]
})



// WEBPACK FOOTER //
// ./src/store/recurring/recurringProphyAmitriptyline.js